module.exports = __webpack_public_path__ + "static/media/habilitacao.a93b068b.svg";